import { BaseAPI } from "@/api/baseAPI";
import type { Branch } from "@/types";

class BranchAPI extends BaseAPI<Branch> {
  constructor() {
    super("branch");
  }
}

export default new BranchAPI();
